module.exports = __webpack_public_path__ + "static/media/thali-wroclaw.76e80655.png";